import { Center, Spinner } from "@chakra-ui/react";

export function Loader() {
  return (
    <Center p="md">
      <Spinner color="brand.500" size="lg" />
    </Center>
  );
}
